import { Card, CardContent, CardHeader } from '@/components/ui/card'
import { Separator } from '@/components/ui/separator'
import { Skeleton } from '@/components/ui/skeleton'

type PropsType = {
  /**
   * Number of field rows to show (default: 4)
   */
  fieldRows?: number
  /**
   * Whether to show a translations section (default: true)
   */
  showTranslations?: boolean
  /**
   * Number of translation tabs to show (default: 3)
   */
  translationTabs?: number
  /**
   * Whether to show a pictures section (default: false)
   */
  showPictures?: boolean
  /**
   * Whether to show a files section (default: false)
   */
  showFiles?: boolean
}

const FormSkeleton = ({
  fieldRows = 4,
  showTranslations = true,
  translationTabs = 3,
  showPictures = false,
  showFiles = false
}: PropsType) => {
  return (
    <Card>
      <CardHeader>
        <Skeleton className="h-6 w-48" />
      </CardHeader>
      <CardContent className="space-y-6">
        {/* Field Rows */}
        {Array.from({ length: fieldRows }).map((_, index) => (
          <div key={index}>
            <div className="grid grid-cols-1 gap-4 md:grid-cols-1 lg:grid-cols-2">
              <div className="space-y-2">
                <Skeleton className="h-4 w-20" />
                <Skeleton className="h-10 w-full" />
              </div>
              <div className="space-y-2">
                <Skeleton className="h-4 w-24" />
                <Skeleton className="h-10 w-full" />
              </div>
            </div>
            {index < fieldRows - 1 && <Separator className="mt-6" />}
          </div>
        ))}

        {/* Pictures Section */}
        {showPictures && (
          <>
            <Separator />
            <div className="space-y-4">
              <Skeleton className="h-6 w-32" />
              <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 md:grid-cols-4">
                {Array.from({ length: 4 }).map((_, index) => (
                  <Skeleton key={index} className="aspect-square w-full" />
                ))}
              </div>
            </div>
          </>
        )}

        {/* Files Section */}
        {showFiles && (
          <>
            <Separator />
            <div className="space-y-4">
              <Skeleton className="h-6 w-32" />
              <div className="space-y-2">
                {Array.from({ length: 3 }).map((_, index) => (
                  <Skeleton key={index} className="h-16 w-full" />
                ))}
              </div>
            </div>
          </>
        )}

        {/* Translations Section */}
        {showTranslations && (
          <>
            <Separator />
            <div className="space-y-4">
              <Skeleton className="h-6 w-32" />
              <div className="flex gap-2">
                {Array.from({ length: translationTabs }).map((_, index) => (
                  <Skeleton key={index} className="h-10 w-24" />
                ))}
              </div>
              <div className="space-y-4">
                <div className="space-y-2">
                  <Skeleton className="h-4 w-16" />
                  <Skeleton className="h-10 w-full" />
                </div>
                <div className="space-y-2">
                  <Skeleton className="h-4 w-20" />
                  <Skeleton className="h-24 w-full" />
                </div>
              </div>
            </div>
          </>
        )}

        <Separator />

        {/* Actions */}
        <div className="flex items-center justify-between">
          <Skeleton className="h-10 w-24" />
          <Skeleton className="h-10 w-24" />
        </div>
      </CardContent>
    </Card>
  )
}

export default FormSkeleton
